/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../isessionstorage.d.ts" />
/// <reference path="../controllers/screencontrollerbase.ts" />

module App.Common.Controllers {
    'use strict';

    class NotFoundController extends ScreenControllerBase {

        public static $inject = ['$injector'];
        constructor($injector: angular.auto.IInjectorService) {
			super($injector);

			this.title = 'Not found';
			this.warnOnUnsavedChanges = false;
        }

        public beforeInitialize(): angular.IPromise<any> {
            return this.setAuthenticationRequired(false);
        }

		public initialize(): angular.IPromise<any> {
			return this.$q.resolve();
		}

		public back() {
			this.$window.history.back();
		}

    }

    angular
        .module('app.common.controllers')
        .controller('app.common.controllers.notFoundController', NotFoundController);
}